import script from "./DefaultPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultPopUp.vue?vue&type=style&index=0&id=1fe10dc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe10dc8"]])

export default __exports__